import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
export function Hero() {
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-20 pb-24 md:pt-32 md:pb-32 overflow-hidden bg-paper-texture bg-heritage-cream" data-id="element-57">
      <div className="max-w-6xl mx-auto px-6 content-relative" data-id="element-58">
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20" data-id="element-59">
          <div className="w-full md:w-1/2 space-y-8 text-center md:text-left" data-id="element-60">
            <FadeIn data-id="element-61">
              <div className="inline-block px-4 py-1.5 mb-4 rounded-full border border-heritage-gold/30 bg-heritage-gold/10 text-heritage-terracotta font-medium text-sm tracking-wide uppercase" data-id="element-62">
                Para las matriarcas de la familia
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-63">
                No permitas que el "sazón de la abuela" se convierta solo en un
                recuerdo:{' '}
                <span className="text-heritage-terracotta italic" data-id="element-64">
                  Rescata tu legado familiar hoy.
                </span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-65">
              <h2 className="text-xl md:text-2xl text-heritage-coffee/80 font-serif leading-relaxed" data-id="element-66">
                El sistema paso a paso para que las matriarcas latinas
                carbonicen sus recetas, secretos y anécdotas en un tesoro eterno
                para sus nietos.
              </h2>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-67">
              <div className="pt-4" data-id="element-68">
                <Button onClick={scrollToOffer} className="w-full md:w-auto text-xl py-5 px-10" data-id="element-69">
                  ¡QUIERO COMENZAR MI LEGADO AHORA!
                </Button>
                <p className="mt-4 text-sm text-heritage-coffee/60 font-serif italic text-center md:text-left" data-id="element-70">
                  Pago seguro y descarga instantánea.
                </p>
              </div>
            </FadeIn>
          </div>

          <div className="w-full md:w-1/2" data-id="element-71">
            <FadeIn delay={0.3} data-id="element-72">
              <div className="relative" data-id="element-73">
                {/* Decorative background blob/shape */}
                <div className="absolute inset-0 bg-heritage-gold/20 rounded-full blur-3xl transform scale-110 -z-10" data-id="element-74"></div>
                <img src="https://cdn.magicpatterns.com/uploads/tfCB9JCYuQx4PP67yJEaPz/LEGADO_DE_SABORES.png" alt="Legado de Sabores eBook en iPad sobre mesa de madera" className="w-full h-auto rounded-lg shadow-2xl transform md:-rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-75" />
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}